import React, { useState } from 'react';

import Button from 'CommonComponents/Button';

export default function ExpenseAttachmentDetailsIndex(props) {
    const [request, setRequest] = useState(false);

    const removeAttachment = () => {
        setRequest(true);
        axios
            .delete(props.attachment.deleteUrl)
            .then((res) => {
                setRequest(false);
                props.fetchAttachment();
            })
            .catch((e) => {
                setRequest(false);
            });
    };

    return (
        <div className="row no-gutters mx-n2 mb-3">
            <div className="col-12 px-3">
                <div className="card bg-white border-0 rounded-15px shadow h-100">
                    <div className="card-body">
                        <div className="d-flex justify-content-start">
                            <div className="mr-3">
                                <Button as="a" variant="primary" href={props.attachment.url} target={'_blank'}>
                                    {$t('Show attachment')}
                                </Button>
                            </div>
                            <div>
                                <Button variant="danger" disabled={request} onClick={removeAttachment}>
                                    {$t('Remove attachment')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
